import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {
  isFetching,
  getMappedFees,
  getAllPaymentMethods,
  getPaymentRecord,
} from '../../../state/reducers/PaymentReducer';
import { getData } from '../../../state/reducers/ApplicationReducer';
import PaymentCard from './PaymentCard';
import { isLAO } from '../../../state/reducers/LoginReducer';
import PaymentActions from '../../../state/actions/PaymentActions';
import ApplicationActions from '../../../state/actions/ApplicationActions';

function mapStateToProps(state) {
  let data = getData(state);
  let fees = getMappedFees(state) || {};
  let fee = fees[data.countryId] || fees['1'] || {};

  return {
    fee,
    visatypeId: data.visatypeId,
    isLAO: isLAO(state),
    paymentRecord: getPaymentRecord(state),
    firstName: data.nameFirst || '',
    lastName: data.nameLast || '',
    passportNumber: data.passportNo || '',
    isFetching: isFetching(state),
    paymentMethods: getAllPaymentMethods(state),
  };
}

let {
  performCashPaymentFlow,
  performMockPaymentFlow,
  getPaymentMethodsRequest,
  getQuoteRequest,
  getFeesRequest,
  submitPaymentRequest,
  sendPaymentLink,
  markForLocalPayment,
  payFailure,
} = PaymentActions;

let { getApplicationRequest } = ApplicationActions;

export default compose(
  connect(mapStateToProps, {
    getApplication: getApplicationRequest,
    performCashPaymentFlow,
    performMockPaymentFlow,
    getQuoteRequest,
    getFeesRequest,
    submitPaymentRequest,
    getPaymentMethods: getPaymentMethodsRequest,
    sendPaymentLink,
    markForLocalPayment,
    payFailure,
  })
)(PaymentCard);



// WEBPACK FOOTER //
// ./src/view/forms/Payment/index.js